import type { ExpandedState, OnChangeFn } from '@tanstack/react-table';
import { useCallback } from 'react';
import { useSafeSessionStorage, useStorageKey } from '../../../../tools/storage.js';

type UseRowExpansionProps = {
    id: string;
};

export function useRowExpansion({ id }: UseRowExpansionProps) {
    const sessionStorageKey = useStorageKey({
        base: 'resizable-table',
        utility: 'expanded-rows',
        id,
        version: 1,
    });

    const [expandedRows, setExpandedRows] = useSafeSessionStorage<ExpandedState>(sessionStorageKey, () => ({}));

    const updateExpandedRows: OnChangeFn<ExpandedState> = useCallback(
        (updateFnOrValue) => {
            // get the updated value
            const updatedValue =
                typeof updateFnOrValue === 'function'
                    ? // function
                      updateFnOrValue(expandedRows)
                    : // value
                      updateFnOrValue;

            setExpandedRows(updatedValue);
        },
        [expandedRows, setExpandedRows]
    );

    const resetExpandedRows = useCallback(() => {
        setExpandedRows({});
    }, [setExpandedRows]);

    return {
        expandedRows,
        setExpandedRows,
        resetExpandedRows,
        updateExpandedRows,
    };
}
